import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { DocumentDirectory } from '@app/models';

export const {
  initialState: documentDirectoryInitialState,
  selectors: documentDirectorySelectors,
  facade: DocumentDirectoryFacadeBase,
} = buildState(DocumentDirectory);

export function documentDirectoryReducer(
  state = documentDirectoryInitialState
): IEntityState<DocumentDirectory> {
  return state;
}
